import { ref } from 'vue';

export default function useFormLevel(props, resource) {
  let legacyFormLevel;
  if (typeof props.settings?.extendedEdit !== 'undefined') {
    legacyFormLevel = props.settings.extendedEdit ? 'advanced' : 'basic';
  }

  const formLevel = ref(legacyFormLevel ?? resource.meta.adjustments.formLevel ?? 'advanced');

  return {
    formLevel,
  };
}
